/**
 * Campo de formulário: rótulo + controle + dica/erro, ligados por id/aria.
 * `controlClass` dá o visual único de input/select/textarea.
 */
import { createElement as h, useId, type ReactElement, type ReactNode } from "react";
import { cx } from "./cx.js";

export const controlClass =
  "min-h-[44px] w-full rounded-control border border-border-strong bg-surface px-3 text-base text-ink hover:border-ink " +
  "placeholder:text-muted focus-visible:outline-none";

export interface FieldProps {
  label: string;
  hint?: string;
  error?: string;
  className?: string;
  /** Recebe os ids para ligar ao controle. */
  children: (ids: { id: string; describedBy?: string; invalid: boolean }) => ReactNode;
}

export function Field({ label, hint, error, className, children }: FieldProps): ReactElement {
  const id = useId();
  const noteId = error || hint ? `${id}-note` : undefined;
  return h(
    "div",
    { className: cx("flex flex-col gap-1", className) },
    h("label", { htmlFor: id, className: "text-sm font-extrabold text-ink" }, label),
    children({ id, describedBy: noteId, invalid: Boolean(error) }),
    noteId
      ? h("p", { id: noteId, className: cx("text-xs", error ? "font-semibold text-danger" : "text-muted") }, error ?? hint)
      : null
  );
}
